// extracted by mini-css-extract-plugin
export default {"classFor":"ControlElement_classFor__lCB8c","inp":"ControlElement_inp__ItUPE"};